import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import { defineTexturedGlassPatterns } from './lib/glassPatternsDefs';
import { KOEFF, KOEFF_X, KOEFF_Y, FRAME_WIDTH, OFFSET_X, OFFSET_Y } from './PleatedSreenConstants';


/*
Frosted, Sandblast, Chinchilla, Gluechip, Rain blast, Pinhead, Acid Edged
*/
const DrawScreen = ({ doorData = null, pattern = 'Rain blast' }) => {
  const svgRef = useRef(null);
  const canvasW = doorData?.frameData?.frameWidth * KOEFF_X + 45;
  const canvasH = doorData?.frameData?.frameHeight * KOEFF_Y + 50;

  useEffect(() => {
    if (parseInt(doorData?.frameData?.frameWidth) <= 9) { return 1;}
    /*
    if (parseInt(doorData?.frameData?.frameWidth) <30 || parseInt(doorData?.frameData?.frameWidth) > 200) {
      return;
    }
    if (parseInt(doorData?.frameData?.frameHeight) < 40 || parseInt(doorData?.frameData?.frameHeight) > 120) {
        return;
    }
    */
   //if (doorData?.frameData?.isValid === false) { return; }
    const svg = initSvg();
    drawSimpleRect(svg, doorData, pattern);
    //enclosure(svg, 500, 500, "caption", "wLabel", "hLabel");
    //enclosure(svg, 500, 500, "My Caption", "500 mm", "500 mm");
 

  }, [doorData]);

  function initSvg() {
    // Clear existing SVG
    d3.select(svgRef.current).selectAll('*').remove();

    // Create SVG element
    const svg = d3
      .select(svgRef.current)
      .attr('width', canvasW)
      .attr('height', canvasH);
      //.style('border', '1px solid black');

    return svg;
  }
  function drawGlassRectangle(svg, offsetX, offsetY, rectWidth, rectHeight, glassDesign) {
    // 1. Define the pattern based on glassDesign
    defineTexturedGlassPatterns(svg, glassDesign);
  
    // 2. Compute pattern ID
    const patternId = glassDesign.toLowerCase().replace(/\s/g, '') + 'Pattern';
  
    // 3. Draw the rectangle with pattern fill
    svg
      .append('rect')
      .attr('x', offsetX + FRAME_WIDTH)
      .attr('y', offsetY + FRAME_WIDTH)
      .attr('width', rectWidth - 2 * FRAME_WIDTH)
      .attr('height', rectHeight - 2 * FRAME_WIDTH)
      .attr('fill', `url(#${patternId})`) // ← use pattern fill
      .attr('stroke', 'black')
      .attr('stroke-width', 1);
  }
  
  function drawSimpleRect(svg, data = null, pattern = 'Rain blast') {
    //  alert(parseInt(doorData?.frameData?.frameheight) * 4)
    const w = parseInt(doorData?.frameData?.frameWidth) * KOEFF_X ;
    const h = parseInt(doorData?.frameData?.frameHeight) * KOEFF_Y;
    const offsetX = OFFSET_X;
    const offsetY = OFFSET_Y;
    const rectWidth = w - offsetX;
    const rectHeight = h - offsetY;
    let baseColor = 'rgba(200, 200, 200, 0.2)'; //lightgrey
    if (doorData?.frameData?.screenFrameColor) {
      //baseColor = doorData.frameData.screenFrameColor; //so far doesn't work
    }

    // Draw main rectangle
    if (data?.frameData?.selectedDoor?.id === 1){
        svg
          .append('rect')
          .attr('x', offsetX)
          .attr('y', offsetY)
          .attr('width', rectWidth)
          .attr('height', rectHeight)
          .attr('fill', 'white')
          .attr('stroke', 'black')
          .attr('stroke-width', 1);
        if (true) {
        svg
          .append('rect')
          .attr('x', offsetX + FRAME_WIDTH)
          .attr('y', offsetY + FRAME_WIDTH)
          .attr('width', rectWidth - 2*FRAME_WIDTH)
          .attr('height', rectHeight - 2*FRAME_WIDTH)
          .attr('fill', baseColor) 
          .attr('stroke', 'black')
          .attr('stroke-width', 1);
        }
        if (true) {        
          drawGlassRectangle(svg, offsetX + FRAME_WIDTH, offsetY + FRAME_WIDTH, 
                                  rectWidth - 2*FRAME_WIDTH,  
                                  rectHeight - 2*FRAME_WIDTH, pattern);
        }
    }
    if (data?.frameData?.selectedDoor?.id === 2){
      svg
        .append('rect')
        .attr('x', offsetX)
        .attr('y', offsetY)
        .attr('width', rectWidth)
        .attr('height', rectHeight)
        .attr('fill', 'white')
        .attr('stroke', 'black')
        .attr('stroke-width', 1);

      if (true){  
      svg
        .append('rect')
        .attr('x', offsetX + FRAME_WIDTH)
        .attr('y', offsetY + FRAME_WIDTH)
        .attr('width', rectWidth/2 - 2*FRAME_WIDTH)
        .attr('height', rectHeight - 2*FRAME_WIDTH)
        .attr('fill', baseColor) //'lightgrey'
        .attr('stroke', 'black')
        .attr('stroke-width', 1);

      svg
        .append('rect')
        .attr('x', offsetX + rectWidth/2 + FRAME_WIDTH)
        .attr('y', offsetY + FRAME_WIDTH)
        .attr('width', rectWidth/2 - 2*FRAME_WIDTH)
        .attr('height', rectHeight - 2*FRAME_WIDTH)
        .attr('fill', baseColor) //lightgrey
        .attr('stroke', 'black')
        .attr('stroke-width', 1);
      }
      if (true){
        drawGlassRectangle(svg, offsetX , offsetY , rectWidth/2,  rectHeight, pattern);
        drawGlassRectangle(svg, offsetX + rectWidth/2 , offsetY , rectWidth/2 ,  rectHeight , pattern);
      }

  }

    // Width dimension line
    svg
      .append("line")
      .attr("x1", offsetX)
      .attr("y1", h + 10)
      .attr("x2", offsetX + rectWidth)
      .attr("y2", h + 10)
      .attr("stroke", "blue")
      .attr("stroke-width", 1);

    // Width label
    svg
      .append("text")
      .attr("x", offsetX + rectWidth / 2)
      .attr("y", h + 25)
      .attr("text-anchor", "middle")
      .attr("font-size", "14px")
      .text(`${data?.frameData?.frameWidthLabel?.replace(/"?$/, '"')}`);

    // Height dimension line
    svg
      .append("line")
      .attr("x1", w + 10)
      .attr("y1", offsetY)
      .attr("x2", w + 10)
      .attr("y2", offsetY + rectHeight)
      .attr("stroke", "blue")
      .attr("stroke-width", 1);

      // Height label (horizontal)
      svg
      .append("text")
      .attr("x", w + 15) // Shift right a bit
      .attr("y", offsetY + rectHeight / 2) // Vertically center
      .attr("text-anchor", "start")
      .attr("font-size", "14px")
      .text(`${data.frameData.frameHeightLabel.replace(/"?$/, '"')}`);


}


  return (
    <div style={{ display: 'inline-block', marginLeft: '0ch', border: '0px solid black', padding: '4px' }}>
      {doorData?.frameData?.selectedDoor && <div style={{ marginLeft: '3ch' }}><b>Front View</b></div>} 
      {/*<p>DrawScreen (rectangle 100x200)</p>*/}
      <svg ref={svgRef}></svg>
    </div>
  );
};

export default DrawScreen;
